import FormUtils from '@/utils/FormUtils';
import CalendarUtils from '@/utils/CalendarUtils';

export default class PaymentUtils {
  static submitExpressPayment (instance, config) {
    let formDataToSend = { payments: [] };
    let ordersForPayment = config.orders.filter(item => item.is_completed_weighting && item.available_settlement_methods.length && Number(item.price) !== (Number(item.payment_cash) + Number(item.payment_transferred) + Number(item.payment_card)));
    if (config.selectedOrdersIDs.length) {
      ordersForPayment = ordersForPayment.filter(item => config.selectedOrdersIDs.indexOf(item.id) > -1);
    }

    for (let i = 0; i < ordersForPayment.length; i++) {
      let currentOrder = ordersForPayment[i];
      let paymentMethod = currentOrder.settlement_method;
      if (currentOrder.available_settlement_methods.length && !currentOrder.available_settlement_methods.find(item => item.id === currentOrder.settlement_method)) {
        paymentMethod = currentOrder.available_settlement_methods[0].id;
      }

      let alreadyPaid = currentOrder.payment_transferred + currentOrder.payment_cash + currentOrder.payment_card;
      let leftToPay = (currentOrder.price - alreadyPaid).toFixed(2);

      formDataToSend.payments.push({
        amount: Number(leftToPay),
        payment_date: CalendarUtils.formatDateForPHP(new Date()),
        settlement_method: paymentMethod,
        customer_id: currentOrder.customer_id,
        order_id: currentOrder.id
      });
    }

    FormUtils.submit(instance, {
      endpoint: '/customers/add-payments',
      formData: formDataToSend,
      successTitle: 'Płatność ekspresowa',
      successText: config.isSinglePayment ? 'Płatność ekspresowa dla wybranego zamówienia została dodana' : 'Płatność ekspresowa dla wybranych zamówień została dodana',
      errorTitle: 'Wystąpił błąd',
      errorText: 'Płatność ekspresowa nie powiodła się. Spróbuj ponownie.',
      successAction: config.successAction,
      failAction: config.failAction
    });
  }

  static submitExpressSettlement (instance, config) {
    FormUtils.submit(instance, {
      endpoint: '/customers/add-settlement-payment/' + parseInt(config.settlementID, 10),
      successTitle: 'Rozliczenie faktury',
      successText: 'Wybrana faktura została opłacona',
      errorTitle: 'Wystąpił błąd',
      errorText: 'Oznaczenie faktury jako opłaconej nie powiodło się. Spróbuj ponownie.',
      successAction: config.successAction,
      failAction: config.failAction
    });
  }
}
